<div class="password-meter-wrapper" data-layout="column">
    <mat-progress-bar *ngIf="showStrength" mode="determinate" [value]="strength" [color]="Theme"></mat-progress-bar>
    <mat-divider *ngIf="!showStrength" class="dividerr"></mat-divider>
    <div *ngIf="showStrength" class="password-status">{{ Label }}</div>
</div>
